import http from "../../http-common";

class LoginService {
    login(data) {
        return http.post(`/profile/login`, data);
    }

    getProfile(id, data) {
        return http.post(`/profile/${id}`, data);
    }

    profileUpdate(id, data) {
        return http.post(`/profile/update/${id}`, data);
    }

    passwordUpdate(id, data) {
        return http.post(`/profile/passwordUpdate/${id}`, data);
    }

    // The emailed token is the proof; the server looks up whose it is
    checkResetToken(token) {
        return http.post('/profile/resetPassword/check', { token });
    }

    resetPassword(token, cPassword) {
        return http.post('/profile/resetPassword', { token, cPassword });
    }

    getRoleNames(data) {
        return http.post(`/profile/getRoleNames`, data);
    }

    sendMail(data) {
        return http.post(`/profile/sendMail`, data);
    }
}

export default new LoginService();